import { RoleAction } from "../../enums/permission-actions";
import RoleConfig from "./RoleConfig.json";

export function IsActionEnabled(actionId: RoleAction, userGroups: string[]): boolean {
  // Based on the context of the button passed in, allow or not allow the user to use the button or component
  // Working with disabled tags, true blocks access, false allows access
  //var isDisabled: boolean = true;
  const requiredRole = RoleConfig.Roles.find((role) => {
    if (userGroups.includes(role.RoleName)) {
      if (role.Policies.includes(actionId)) {
        return true;
      }
    }
    return false;
  });

  return requiredRole ? true : false;
}
